import React, { useState, useContext } from "react";
import { Spin } from "antd";
import Header from "./Header";
import WelcomeSection from "./WelcomeSection";
import CourseList from "./CourseList";
import DeadlinesList from "./DeadlinesList";
import LearningStats from "./LearningStats";
import useLearnerDashboard from "PlatForms/OrgLMS/Hooks/LearnerHooks/useLearnerDashboard";
import LearnerTrainingProgress from "./LearnerTrainingProgress";
import { LoadingOutlined } from "@ant-design/icons";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
const LearnerDashboard = () => {
  const { dashboardData, loading, error } = useLearnerDashboard();
  const [darkMode, setDarkMode] = useState(false);
  const { isProfileComplete } = useContext(ProfileContext);
  const spinnerIcon = <LoadingOutlined style={{ fontSize: 48, color: "#1890ff" }} spin />;
  if (loading) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        backgroundColor: darkMode ? "#141414" : "#fff",
      }}>
        <Spin indicator={spinnerIcon} tip="Loading..." size="large" />
      </div>
    );
  }
  if (error) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "80vh",
        color: darkMode ? "#fff" : "#000",
      }}>
        ⚠️ Error: {error}
      </div>
    );
  }
  if (!dashboardData) {
    return <div style={{ padding: "12px" }}>No data available</div>;
  }
  return (
    <div style={{
      maxWidth: 1400,
      margin: "0 auto",
      padding: "12px",
      backgroundColor: darkMode ? "#141414" : "#f0f2f5",
      minHeight: "100vh",
    }}>
      <Header darkMode={darkMode} setDarkMode={setDarkMode} />
      <WelcomeSection
        darkMode={darkMode}
        lastLogin={dashboardData.lastLogin}
        learner={dashboardData.learner}
        currentCourses={dashboardData?.learningStats?.currentCourses ?? 0}
      />
      <div style={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 2fr) minmax(0, 1fr)",
        gap: "8px",
        marginTop: "8px"
      }}>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <CourseList
            darkMode={darkMode}
            enrolledCourses={dashboardData.trainings}
          />
          <LearnerTrainingProgress darkMode={darkMode} />
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
          <DeadlinesList
            darkMode={darkMode}
            upcomingDeadlines={dashboardData.upcomingDeadlines}
          />
          <LearningStats
            darkMode={darkMode}
            learningStates={dashboardData.learningStats}
          />
        </div>
      </div>
    </div>
  );
};
export default LearnerDashboard;
